import { FileTypeIcon } from "./FileTypeIcon";

export default FileTypeIcon;
